<template>
  <div v-if="isLoaded">
    <div class="content-body"
         v-bind:class="{ fullscreen_expand: isFullscreen }">
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card"
               style="">
            <div class="card-header">
              <h4 class="card-title">CFOP</h4>
              <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
              <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                <ul class="list-inline mb-0">
                  <li><a @click="onCreate()"
                         v-b-tooltip
                         title="Cadastrar"><i class="ft-plus"
                                              v-if="getPermission('cfopregra.store')"></i></a></li>
                  <li><a @click="onActivateDesactivate(1, null, false)"
                         v-b-tooltip
                         title="Ativar Registros"
                         v-if="getPermission('cfopregra.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                  <li><a @click="onActivateDesactivate(2, null, false)"
                         v-b-tooltip
                         title="Inativar Registros"
                         v-if="getPermission('cfopregra.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                  <li><a @click="expandFullscreen()"
                         v-b-tooltip
                         title="Expande a tela"
                         v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                  <li><a @click="expandFullscreen()"
                         v-b-tooltip
                         title="Minimiza a tela"
                         v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                  <li><a @click="onFilterShowHide()"
                         v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar>
                  </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData"
                       v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner v-if="loadingData"
                               text-fg-color="#ffffff"
                               message="Carregando..."></spinner>
                    </div>
                  </div>
                  <vuetable ref="vuetable"
                            api-url="/api/cfopregra"
                            :fields="fields"
                            :css="css"
                            :append-params="moreParams"
                            track-by="cforeg_id"
                            pagination-path=""
                            detail-row-component="cfopregra-detalhes"
                            @vuetable:cell-clicked="onDetail"
                            @vuetable:load-error="onError"
                            @vuetable:pagination-data="onPaginationData"
                            @vuetable:loaded="onLoaded">
                    <template slot="status" slot-scope="props">
                      <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                      <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                    </template>
                    <template slot="tp_processo" slot-scope="props">
                      <span class="badge badge-success" v-if="props.rowData.tp_processo!=null &&props.rowData.tp_processo.valor==1">{{ props.rowData.tp_processo.descr }}</span>
                      <span class="badge badge-danger" v-if="props.rowData.tp_processo!=null &&props.rowData.tp_processo.valor==2">{{ props.rowData.tp_processo.descr }}</span>
                    </template>
                    <template slot="param_categoria_cfop" slot-scope="props">
                      <span v-if="props.rowData.param_categoria_cfop!=null">{{ props.rowData.param_categoria_cfop.descr }}</span>
                    </template>
                    <template slot="cfop_estadual" slot-scope="props">
                      <span v-if="props.rowData.cfop_estadual!=null">{{props.rowData.cfop_estadual.cd}} - {{ props.rowData.cfop_estadual.descr }}</span>
                    </template>
                    <template slot="cfop_exterior" slot-scope="props">
                      <span v-if="props.rowData.cfop_exterior!=null">{{props.rowData.cfop_exterior.cd}} - {{ props.rowData.cfop_exterior.descr }}</span>
                    </template>
                    <template slot="cfop_municipal" slot-scope="props">
                      <span v-if="props.rowData.cfop_municipal!=null">{{props.rowData.cfop_municipal.cd}} - {{ props.rowData.cfop_municipal.descr }}</span>
                    </template>
                    <template slot="cfop_interestadual" slot-scope="props">
                      <span v-if="props.rowData.cfop_interestadual!=null">{{props.rowData.cfop_interestadual.cd}} - {{ props.rowData.cfop_interestadual.descr }}</span>
                    </template>
                    <template slot="transportadora_uf" slot-scope="props">
                      <span class="badge badge-success" v-if="props.rowData.transportadora_uf!=null &&props.rowData.transportadora_uf.valor==1">{{ props.rowData.transportadora_uf.descr }}</span>
                      <span class="badge badge-danger" v-if="props.rowData.transportadora_uf!=null &&props.rowData.transportadora_uf.valor==2">{{ props.rowData.transportadora_uf.descr }}</span>
                    </template>

                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a @click="onEdit(props.rowData, props.rowIndex)" v-b-tooltip title="Editar"  v-if="getPermission('cfopregra.update')"><i class="fa fa-edit"></i></a>
                        <span v-if="getPermission('cfopregra.status')">
                            <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                            <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                        </span>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class='col-md-12'>
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info ref="paginationInfo"
                                                :css="css.pagination"
                                                info-class="pull-left"></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination ref="pagination"
                                           :css="css.pagination"
                                           @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CfopRegraForm ref="cfopregraform" />
    </div>
  </div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import CfopRegraFilterBar from './CfopRegraFilterBar'
import CfopRegraDetalhes from './CfopRegraDetalhes'
import CfopRegraForm from './CfopRegraForm'

Vue.component('cfopregra-detalhes', CfopRegraDetalhes);
export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    CfopRegraForm,
    'vuetable-filterbar': CfopRegraFilterBar
  },
  data() {
    return {
      dataExport: [],
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      optionsLivStatus: [],
      optionsLivtpProcesso: [],
      optionsLivtrasnpotadoraUf: [],
      optionsLivCfop: [],
      optionsLivcategoriaCfop: [],
      optionsLivStatusAliquota: [],
      helpForm: new Form({
        recordCollection: [],
        status: '',
        params: []
      }),
      fields: [{
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
      },
        {
          name: '__slot:tp_processo',
          title: 'Tipo de Processo',
          sortField: 'tp_processo'
        },
        {
          name: 'cd',
          title: 'Código',
          sortField: 'cd'
        },
        {
          name: 'descr',
          title: 'Descrição',
          sortField: 'descr'
        },
        {
          name: '__slot:transportadora_uf',
          title: 'Transportador = UF origem',
          sortField: 'transportadora_uf'
        },
        {
          name: '__slot:param_categoria_cfop',
          title: 'Categoria'
        },
        {
          name: '__slot:cfop_estadual',
          title: 'Estadual',
          sortField: 'cfop_estadual'
        },
        {
          name: '__slot:cfop_interestadual',
          title: 'Interestadual',
          sortField: 'cfop_interestadual'
        },
        {
          name: '__slot:cfop_municipal',
          title: 'Municipal',
          sortField: 'cfop_municipal'
        },
        {
          name: '__slot:cfop_exterior',
          title: 'Exterior',
          sortField: 'cfop_exterior'
        },
        {
          name: '__slot:status',
          title: 'Status',
          sortField: 'status'
        },
        {
          name: '__slot:actions', // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
        }
      ],
      css: {
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
    }
  },
  mounted() {
    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
    this.$events.$on('filter-reset', e => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on('reloadVuetable', function(data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page)
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        'cd': data_filter.cd,
        'descr': data_filter.descr,
        'status': data_filter.status.value
      }
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      })
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {}
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit('setVuetableFilterRow', false);
      } else {
        this.$store.commit('setVuetableFilterRow', true);
      }
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onLoaded: function() {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit('setVuetableFilterButton', false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.cforeg_id);
    },
    getLivGeral() {
      this.helpForm
          .get("/api/cfopregra/jsonlistgeral")
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj) => {
              this.optionsLivStatus.push({
                label: obj.descr,
                value: obj.valor
              })
            })
            response.categoria_cfop.forEach((obj) => {
              this.optionsLivcategoriaCfop.push({
                label: obj.descr,
                value: obj.parcatcfo_id
              })
            })
            response.tp_processo.forEach((obj) => {
              this.optionsLivtpProcesso.push({
                label: obj.descr,
                value: obj.valor
              })
            })
            response.transportadora_uf.forEach((obj) => {
              this.optionsLivtrasnpotadoraUf.push({
                label: obj.descr,
                value: obj.valor
              })
            })
            response.cfop.forEach((obj) => {
              this.optionsLivCfop.push({
                label: obj.cd + "-"+ obj.descr,
                value: obj.cfop_id
              })
            })
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
    },
    onCreate() {
      this.$refs.cfopregraform.onCreate();
    },
    onEdit(data, index) {
      this.$refs.cfopregraform.onEdit(data);
    },
    getLivStatus() {
      this.helpForm.params = {
        tabela: 'cfop_regra',
        coluna: 'status'
      };
      this.helpForm.get('/api/listitemvalor/jsonlist').then(response => {
        new ReturnApi(response, this, true, false, false);
        response.items.forEach((obj) => {
          this.optionsLivStatus.push({
            label: obj.descr,
            value: obj.valor
          })
        })
      })
      .catch(errors => {
        new ReturnApi(errors, this)
      });
    },
    getLivStatusAliquota() {
      this.helpForm.params = {
        tabela: 'cfop_natureza_aliquota',
        coluna: 'status'
      };

      this.helpForm.get('/api/listitemvalor/jsonlist').then(response => {
        new ReturnApi(response, this, true, false, false);
        response.items.forEach((obj) => {
          this.optionsLivStatusAliquota.push({
            label: obj.descr,
            value: obj.valor
          })
        })
      })
          .catch(errors => {
            new ReturnApi(errors, this)
          });
    },
    onActivateDesactivate(action, data, tipo)
    {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if(tipo)
      {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.cforeg_id );
      }
      else
      {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj)=>{
          this.helpForm.recordCollection.push(obj)
        });
      }
      this.$refs.cfopregraform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
}

</script>
